module.exports = __webpack_public_path__ + "public/img/biaoge.72ff7b60.png";